import { useState } from 'react';
import { Grid, Paper, Tabs, Tab } from '@mui/material';
import { makeStyles } from "tss-react/mui";
import HeroBanner from '../Components/PagesComponents/Website/HeroBanner';
import NewsAndEvents from '../Components/PagesComponents/Website/NewsAndEvents';
import OfficeMember from '../Components/PagesComponents/Website/OfficeMember';
import ContactUs from '../Components/PagesComponents/Website/ContactUs';
import PrivacyPolicy from '../Components/PagesComponents/Website/privacyPolicy';
import TermsAndConditions from '../Components/PagesComponents/Website/termsAndConditions';
import AboutUs from '../Components/PagesComponents/Website/AboutUs';
import PressAndMediaCoverage from '../Components/PagesComponents/Website/PressAndMediaCoverage';
import Press from '../Components/PagesComponents/Website/Press';

const useStyles = makeStyles()((theme) => {
  return {
    verticalTab: {
      '&.MuiTabs-vertical ': {
        borderRight: '0px solid'
      },
      '& .MuiTab-root ': {
        backgroundColor: "#fff",
        textTransform: 'capitalize',
        alignItems: 'flex-start',
        marginBottom: '1px',
        borderRadius: '0px',
      },
      '& .MuiTab-root.Mui-selected ': {
        backgroundColor: '#3E4094',
        color: '#fff'
      },
      '& .MuiTabs-indicator ': {
        width: '0px'
      }
    },
    tab: {
      textAlign: 'left',
      fontWeight: 500,

      borderRadius: '4px',
      marginBottom: '8px',
    }
  };
});

const Website = () => {
  const { classes } = useStyles();

  const tabItems = [
    { Content: <HeroBanner />, accessKey: 'Hero Banner' },
    { Content: <AboutUs />, accessKey: 'About Us' },
    { Content: <NewsAndEvents />, accessKey: 'News & Events' },
    { Content: <OfficeMember />, accessKey: 'Office Member' },
    { Content: <ContactUs />, accessKey: 'Contact Us Request' },
    { Content: <PrivacyPolicy />, accessKey: 'Privacy Policy' },
    { Content: <TermsAndConditions />, accessKey: 'Terms & Conditions' },
    { Content: <PressAndMediaCoverage />, accessKey: 'Press & Media Coverage' },
    { Content: <Press />, accessKey: 'Press' },
  ];
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper elevation={0} sx={{ borderRadius: '24px', padding: '24px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3} lg={3} xl={2}>
              <Tabs
                className={classes.verticalTab}
                orientation="vertical"
                value={selectedTab}
                onChange={handleTabChange}
                sx={{
                  border: '1px solid #f0f0f0',
                  borderRadius: '8px'
                }}
              >
                {tabItems?.map((tab, index) => (
                  <Tab
                    key={tab?.accessKey}
                    label={tab?.accessKey}
                    value={index}
                    className={classes.tab}
                    sx={{
                      '&:hover': {
                        color: selectedTab === index ? 'white' : 'black',
                        backgroundColor: selectedTab === index ? '#4A3AFF' : '#f0f0f0',
                      },
                      backgroundColor: selectedTab === index ? '#4A3AFF' : 'transparent',
                      borderBottom: tabItems?.length !== (index + 1) && '1px solid #f0f0f0'
                    }}
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid item xs={12} md={9} lg={9} xl={10}>
              {tabItems[selectedTab]?.Content}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Website;
